import React, { FC, memo } from 'react'

import { ProductMatchNotifications } from 'modulesCommon/Notifications/components'
import { useMatchNotifications, useNotifications } from 'modulesCommon/Notifications/services'

const ProductMatchNotificationsContainer: FC = memo(() => {
  const { getNotificationsByType } = useNotifications()
  const productMatchNotifications = getNotificationsByType('ProductMatchGcdm')
  const { openMatchedNotification } = useMatchNotifications()

  return <ProductMatchNotifications data={productMatchNotifications} onViewProduct={openMatchedNotification} />
})

export default ProductMatchNotificationsContainer
